import React, { useEffect, useRef } from 'react';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';

import { Container } from './styles';

const CustomSelectComponent = ({
  name,
  placeholder = 'Selecione',
  noOptionsMessage = 'Não há opções',
  label,
  value,
  inputValue,
  options,
  isMulti = false,
  isClearable = false,
  isCreatable = false,
  onCreateOption,
  onChange,
  onKeyDown,
  onInputChange,
  className,
  onSelectResetsInput = true,
  inputMaxLength,
  hasError = false,
  ...rest
}) => {
  const selectRef = useRef(null);

  useEffect(() => {
    if (inputMaxLength) {
      if (selectRef && selectRef.current.control) {
        selectRef.current.control.maxLength = inputMaxLength;
      }
    }
  }, [selectRef]);

  const handleChange = (event) => {
    if (onChange) {
      onChange(event);
    }
  };

  const handleKeyDown = (event) => {
    if (onKeyDown) {
      onKeyDown(event);
    }
  };

  const handleInputChange = (_value, { action }) => {
    if (onInputChange) {
      if (onSelectResetsInput) {
        onInputChange(_value);
      } else {
        switch (action) {
          case 'input-change':
            onInputChange(_value);
        }
      }
    }
  };

  const handleCreateOption = (_inputValue) => {
    if (onCreateOption) {
      onCreateOption(_inputValue);
    }
  };

  return (
    <Container ref={selectRef} className={className} hasError={hasError}>
      {label && <span className="label">{label}</span>}

      {isCreatable ? (
        <CreatableSelect
          options={options}
          value={value}
          placeholder={placeholder}
          onChange={handleChange}
          onCreateOption={handleCreateOption}
          classNamePrefix="react-select"
          isMulti={isMulti}
          isClearable={isClearable}
          formatCreateLabel={(inputValueOnCreate) =>
            `Criar "${inputValueOnCreate}"`
          }
          {...rest}
        />
      ) : (
        <Select
          name={name}
          options={options}
          value={value}
          inputValue={inputValue}
          placeholder={placeholder}
          onChange={handleChange}
          onInputChange={handleInputChange}
          onKeyDown={handleKeyDown}
          classNamePrefix="react-select"
          isMulti={isMulti}
          isClearable={isClearable}
          noOptionsMessage={() => noOptionsMessage}
          {...rest}
        />
      )}
    </Container>
  );
};

export default CustomSelectComponent;
